module.exports = require('../dist/selectors/common');
